import { IAttendanceStudent } from './profile-panels/attendance-panel/attendance-panel.models';
import { IBasicInfoStudent } from './profile-panels/basic-info-panel/basic-info-panel.models';
import { IProfileHeaderStudent } from './profile-header/profile-header.models';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export enum SidebarEvents {
  COLLAPSE_PANELS = 'COLLAPSE_ALL_PANELS',
  EXPAND_PANELS = 'EXPAND_ALL_PANELS',
}

export interface ILoadStudentConfig {
  currentStudent$: BehaviorSubject<IShelterProfileStudent>;
  currentStudentIndex$: BehaviorSubject<number>;
  caresIds: Array<string>;
  route: ActivatedRoute;
  shelterId: string;
}

export type TSidebarEvent = 'COLLAPSE_ALL_PANELS' | 'EXPAND_ALL_PANELS';

export interface IHeaderDataPointConfig {
  studentName: string;
  dataPoints: Array<{ key: Function; human: Function; formatFn: Function }>;
}

export type TValidProfilePanel = 'BASIC_INFO' | 'ATTENDANCE';

export interface ISidebar {
  title: string;
  listData: Array<{
    human: string;
    key: string;
    icon: string;
  }>;
}

export interface IPanel {
  key: string;
  expanded: boolean;
}

export interface IPanels {
  [panelName: string]: IPanel;
}

export interface ISidebarConfig {
  SIDEBAR_COLLAPSE: ISidebar;
  SIDEBAR_EXPAND: ISidebar;
}

export interface IShelterProfileStudent extends IProfileHeaderStudent, IBasicInfoStudent, IAttendanceStudent {}
